import { render, staticRenderFns } from "./PortfolioChoice.vue?vue&type=template&id=1435fd9d&scoped=true"
import script from "./PortfolioChoice.vue?vue&type=script&lang=js"
export * from "./PortfolioChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435fd9d",
  null
  
)

export default component.exports